<template>
  <div>

    <!-- DeviceId -->
    <el-row :gutter="5" style="margin: 20px 0 10px 0">
      <el-col :span="2"/>
      <el-col :span="4">
        <span class="redStar">*</span>{{$t('message.deviceId')}}
      </el-col>
      <el-col :span="16">
        <el-input class="item-width" v-model="deviceId" size="medium" @change="emitDeviceId"/>
      </el-col>
      <el-col :span="2"/>
    </el-row>

    <!-- 设备型号 -->
    <el-row :gutter="5" style="margin: 10px 0 10px 0">
      <el-col :span="2"/>
      <el-col :span="4">
        <span class="redStar">*</span>{{$t('message.model')}}
      </el-col>
      <el-col :span="16">
        <el-select class="item-width" v-model="model" size="medium" :placeholder="$t('message.pleaseChoose')" @change="emitModel">
          <el-option v-for="item in modelOptions" :key="item" :label="item" :value="item"/>
        </el-select>
      </el-col>
      <el-col :span="2"/>
    </el-row>

    <!-- 组 -->
    <el-row :gutter="5" style="margin: 10px 0 10px 0">
      <el-col :span="2"/>
      <el-col :span="4">
        <span class="redStar">*</span>{{$t('message.group')}}
      </el-col>
      <el-col :span="16">
        <el-select class="item-width" v-model="groupValue" size="medium" :placeholder="$t('message.pleaseChoose')" multiple collapse-tags @change="emitGroup">
          <el-option v-for="item in groupOptions" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-col>
      <el-col :span="2"/>
    </el-row>

    <!-- 商户 -->
    <el-row :gutter="5" style="margin: 10px 0 20px 0">
      <el-col :span="2"/>
      <el-col :span="4">
        <span class="redStar">*</span>{{$t('message.merchant')}}
      </el-col>
      <el-col :span="16">
        <el-select class="item-width" v-model="merchantValue" size="medium" :placeholder="$t('message.pleaseChoose')" @change="emitMerchant">
          <el-option v-for="item in merchantOptions" :key="item.id" :label="item.name" :value="item.id"/>
        </el-select>
      </el-col>
      <el-col :span="2"/>
    </el-row>

  </div>

</template>

<script>
  export default {
    name: "TerminalEditTabBaseConfig",

    props:{
      model:{
        required: true
      },
      deviceId:{
        required: true
      },
      merchantValue:{
        required: true
      },
      groupValue:{
        required: true
      }
    },

    data(){
      return{
        groupOptions:[],
        merchantOptions: [],
        modelOptions: ['X990', 'X970', 'X950']
      }
    },

    mounted(){
      this.queryAllGroup();
      this.queryAllMerchant();
    },

    methods:{
      // 获取全部商户
      queryAllMerchant() {
        let _this = this;
        this.$axios({
          method: 'post',
          url: '/marketplace/common/query/merchant',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          }
        }).then(response => {
          if (response.data.resultCode != 0) {
            _this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            this.merchantOptions = response.data.merchants;
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      //获取全部组
      queryAllGroup() {
        let _this = this;
        this.$axios({
          method: 'post',
          url: '/marketplace/common/query/group',
          headers: {
            'Accept-Language': sessionStorage.getItem('acceptLanguage')
          }
        }).then(response => {
          if (response.data.resultCode != 0) {
            _this.$message({
              type: "error",
              message: response.data.desc,
              duration: '3000',
            });
            return;
          } else {
            _this.groupOptions = response.data.groups instanceof Array ? response.data.groups : [];
          }
        }).catch((err) => {
          console.log(err);
        });
      },

      // DeviceId 变更
      emitDeviceId(deviceId){
        this.$emit("emitDeviceId",deviceId);
      },

      // model 变更
      emitModel(model){
        this.$emit("emitModel",model);
      },

      emitGroup(group){
        this.$emit("emitGroup", group);
      },

      // 商户 变更
      emitMerchant(merchant){
        this.$emit("emitMerchant",merchant);
      },
    }
  }
</script>

<style scoped>
  .redStar {
    color: red;
    font-size: 20px;
    font-weight: bold;
    margin-top: 5px;
    margin-right: 10px;
    position: relative;
    top: 6px;
  }

  .item-width {
    width: 60%;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/terminal/TerminalEditTabBaseConfig.vue